export enum DeliveryMode {
    COURIER_SERVICE = 'COURIER_SERVICE',
    PICKUP_POINT = 'PICKUP_POINT',
    TRANSIT = 'TRANSIT',
}

export default DeliveryMode;
